// import img from '../../images/who-can-join.png'
import content_experts from '../../images/who-can-join/content_experts.png'
import freelance_teacher from '../../images/who-can-join/freelance_teacher.jpg'
import individual_student from '../../images/who-can-join/individual_student.jpg'
import publisher from '../../images/who-can-join/publisher.jpg'
import icon1 from '../../images/who-can-join/1.png'
import icon2 from '../../images/who-can-join/2.png'
import icon3 from '../../images/who-can-join/3.png'
import icon4 from '../../images/who-can-join/4.png'
const who_can_join = [
  {
    img: freelance_teacher,
    icon: icon3,
    title: 'Teacher',
    text: [
      'When you work remotely on KATON, your students can watch videos on any topic at any time, and you can choose the hours that work best for you. A freelance KATON tutor can be hired by a single school or several different institutions to tutor students in subjects they struggle with on a per-lesson or per-hour basis. Working on KATON allows you to save a tonne of cash, as the cost of renting a space is not deducted from the money you make selling educational materials. Although printed handouts are a common part of traditional education, there are certain advantages to adopting a more digital approach. With online instruction, you can send them the same materials as digital documents, such as PDFs sent via email, which has the advantage of being more eco-friendly because it allows documents to be easily updated as needed up until the class begins and saves both time and money on printing and paper.',
      'Freelancing on KATON, like any other online teaching platform, does have a learning curve at the outset.',
      "It's possible that you'll need to learn some new skills, such as how to utilize a webcam and microphone, as well as how to use online digital whiteboards and breakout rooms. Lighting can also be an issue that requires practise to master.",
    ],
    list: [
      'Time Flexibility and 24/7 Tutorials',
      'Makes Teaching More Affordable as a Teacher',
      'Information Sharing Made Easier and Greener',
      'A Chance as a Teacher or Trainer to Develop and Master IT Key Skills',
    ],
    tabName: 'teachers',
  },
  {
    img: individual_student,
    icon: icon4,
    title: 'Private Students',
    text: [
      "Over time, KATON has experienced remarkable growth.KATON's goal is a shift from a teacher-centered to a student-centered approach to education, which increases student motivation and academic success.As a result of the proliferation of new technology, pupils have reduced attention spans, making it harder to pique and maintain their interest.KATON helps to elevate the standard of education and broaden the scope of each instructor's and student's interactions.",
      'Lectures and classes are unlimited, Apart from traditional learning, a student can attend the same lecture numerous times without having to ask the professor to repeat it. Every individual possesses the capacity to make use of it, education  that would be both rapid and efficient which speeds up the progress significantly when compared to more traditional routes of instruction delivered in a classroom setting. E-learning places an emphasis on the learner in order to provide the most beneficial educational experience possible.',
    ],
    list: [
      'Unlimited lectures',
      'Up to date',
      'Quick and efficient learning',
      'Students focused',
    ],
    tabName: 'students',
  },
  {
    img: content_experts,
    icon: icon2,
    title: 'Content Experts',
    text: [
      'Content production is an important part of an online learning platform. KATON considers content professionals that know how to turn complicated, expert-level contents that would entice students with pre-reading teasers enhanced with multimedia and engaging with interactive content while sticking to project submission deadlines. We are looking at content with a diversity of topics and extensive information that can keep and attract students to the KATON platform.',
    ],
    list: [
      'Build Trust with students ',
      'High Quality Content Creation',
      'Consistent Content Creation',
      'Detailed and Engaging Content',
    ],
    tabName: 'teachers',
  },
  {
    img: publisher,
    icon: icon1,
    title: 'Publisher',
    text: [
      'Publishing on KATON can help save both time and money by using expertise knowledge to create  Ebooks  which student can purchase at a low rate course and good writing skills  to reach your target students to fill those virtual classrooms.The Internet is flooded with content marketing articles. Nonetheless, exhibiting and reaching a wider audience is made possible with releasing your e-books on KATON.',
      " Having access to in-depth data as a publisher allows you to get more out of your budget and make better use of your resources. Publishers now have access to detailed information on the demographics of your readers, the number of KATON learners who have purchased their courses or ebooks, and the success of various marketing strategies. Having published high-quality articles and books on eLearning reflects well on the publisher's expertise and credibility. Thus, the publisher can establish themselves as a leader in their field , highlights your own specialization in the field.",
    ],
    list: [
      'Establish Yourself As An Industry Expert',
      'Expand Online Presence',
      'Reduce Your Marketing Spending',
      'Gives students the opportunity to review a topic or idea that you have previously presented.',
    ],
    tabName: 'publishers',
  },
]

export default who_can_join
